import first from 'lodash.first';

/**
 * getNewestEntityDate returns the newest date of all the data points in the array
 * of entities
 *
 * @method getNewestEntityDate
 * @param  {Array}           entities   The array of entities
 * @return {Date}                     Date object
 */
function getNewestEntityDate(entities: any[]): any {
  const finiteDates = entities
    .map((entity) => first<any>(entity.data)?.date)
    .filter((date: Date | undefined) => !!date);
  const max = Math.max(...finiteDates);
  return new Date(max);
}

export default getNewestEntityDate;
